import script from "./ListOfAccident.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListOfAccident.vue?vue&type=script&lang=ts&setup=true"

import "./ListOfAccident.vue?vue&type=style&index=0&id=f2532dd6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2532dd6"]])

export default __exports__